import { EcsProjectTeamName } from '../types';

export enum Experiment {
  QuickNavManageMyThings = 'QuickNavManageMyThings',
  MyGroupsAdminOfFilter = 'MyGroupsAdminOfFilter',
  AnalyticsEventsStrictSchema = 'AnalyticsEventsStrictSchema',
  AnalyticsAdminSetting = 'AnalyticsAdminSetting',
  AnswersInVivaGA = 'AnswersInVivaGA',
  AnswerUpvoteRedesign = 'AnswerUpvoteRedesign',
  AnswersOnlyMode = 'AnswersOnlyMode',
  AnswersPostGAExperience = 'AnswersPostGAExperience',
  AtMentionCustomName = 'AtMentionCustomName',
  AutoSuggestionCampaignHashtag = 'AutoSuggestionCampaignHashtag',
  BackendGraphqlApiVnextEndpoint = 'BackendGraphqlApiVnextEndpoint',
  BackendLiveEventFeedCaching = 'BackendLiveEventFeedCaching',
  BackendLiveEventFeedCachingByTenant = 'BackendLiveEventFeedCachingByTenant',
  BackendOcularCosmos = 'BackendOcularCosmos',
  BackendRankieForwardTreatments = 'BackendRankieForwardTreatments',
  BellPageSize = 'BellPageSize',
  BookmarkThread = 'BookmarkThread',
  Campaigns = 'Campaigns',
  CampaignsExecutiveSponsorship = 'CampaignsExecutiveSponsorship',
  CampaignSash = 'CampaignSash',
  CampaignsKillSwitchUI = 'CampaignsKillSwitchUI',
  ClearPublisher = 'ClearPublisher',
  CommunityBadgeAdmin = 'CommunityBadgeAdmin',
  CommunityLiveEventsBanner = 'CommunityLiveEventsBanner',
  CommunityManagerSubscriptionTip = 'CommunityManagerSubscriptionTip',
  CommunitySetupTeachingBubbles = 'CommunitySetupTeachingBubbles',
  CommunitySubscriptionBubbleOnly = 'CommunitySubscriptionBubbleOnly',
  CompanyLogoInLCHeader = 'CompanyLogoInLCHeader',
  CondensedCardHomeFeed = 'CondensedCardHomeFeed',
  ContextualAtMentioning = 'ContextualAtMentioning',
  CSVUploadGroupMembers = 'CSVUploadGroupMembers',
  CSVUploadGroupMembersV2 = 'CSVUploadGroupMembersV2',
  DiscoverCommunitiesV2 = 'DiscoverCommunitiesV2',
  DiscoverOfficialCommunities = 'DiscoverOfficialCommunities',
  DraftPostCommunity = 'DraftPostCommunity',
  DraftPostStoryline = 'DraftPostStoryline',
  DwellTimeReporting = 'DwellTimeReporting',
  EmbedSupportForNetworkContext = 'EmbedSupportForNetworkContext',
  EmbedUseAttachableLinkQuery = 'EmbedUseAttachableLinkQuery',
  EmbedMsal = 'EmbedMsal',
  EnhancedDigestDiscoveryDesign = 'EnhancedDigestDiscoveryDesign',
  ExternalNetworksInGlammer = 'ExternalNetworksInGlammer',
  FavoritesDragDropReorder = 'FavoritesDragDropReorder',
  FollowButtonHomeFeedThreadWithGreyColor = 'FollowButtonHomeFeedThreadWithGreyColor',
  GlammerMomentsNotifications = 'GlammerMomentsNotifications',
  GroupHoverCardV2 = 'GroupHoverCardV2',
  GroupRecommendedFeed = 'GroupRecommendedFeed',
  GroupsFromGrouper = 'GroupsFromGrouper',
  HomeFollowingFeed = 'HomeFollowingFeed',
  InFeedUserSuggestions = 'InFeedUserSuggestions',
  LeaderAudienceFeed = 'LeaderAudienceFeed',
  LeadershipManagement = 'LeadershipManagement',
  LeadersAudienceMS365Groups = 'LeadersAudienceMS365Groups',
  LeadershipLiveEventsBanner = 'LeadershipLiveEventsBanner',
  LeaderGroupsAddAsync = 'LeaderGroupsAddAsync',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LongFormContentArticlePublisher = 'LongFormContentArticlePublisher',
  LongFormContentFormattingOptions = 'LongFormContentFormattingOptions',
  MomentsCreation = 'MomentsCreation',
  MultiTenantOrganization = `MultiTenantOrganization`,
  NotificationsUpsell = 'NotificationsUpsell',
  NotificationsUpsellLongTerm = 'NotificationsUpsellLongTerm',
  OWAStorylinePostFeedback = 'OWAStorylinePostFeedback',
  OWAStorylinesDigestFollowSenderButton = 'OWAStorylinesDigestFollowSenderButton',
  OWAStorylinesDigestStoriesCarousel = 'OWAStorylinesDigestStoriesCarousel',
  OWAStorylinesDigestSuggestedUsers = 'OWAStorylinesDigestSuggestedUsers',
  OWAStorylinesDigestTeachingBubble = 'OWAStorylinesDigestTeachingBubble',
  OdspFilePickerType = 'OdspFilePickerType',
  OfficeTopics = 'OfficeTopics',
  OfficeTopicsWithNetCore = 'OfficeTopicsWithNetCore',
  OfficialCommunityBadge = 'OfficialCommunityBadge',
  OneCameraV3 = 'OneCameraV3',
  OnePlayerNative = 'OnePlayerNative',
  OutlookAnswersDigestTopics = 'OutlookAnswersDigestTopics',
  OutlookPublisherGuide = 'OutlookPublisherGuide',
  OverrideAndDisableStorylineAnnouncements = 'OverrideAndDisableStorylineAnnouncements',
  PageLayoutVNextVivaEngage = 'PageLayoutVNextVivaEngage',
  PageLayoutVNextWebApp = 'PageLayoutVNextWebApp',
  PageThreadHomeFeed = 'PageThreadHomeFeed',
  PeopleSuggestion3SV3 = 'PeopleSuggestion3SV3',
  PinnedFiles = 'PinnedFiles',
  PublisherAbandonmentOCVSurvey = 'PublisherAbandonmentOCVSurvey',
  PublisherSuggestedTopics = 'PublisherSuggestedTopics',
  PWAUpsell = 'PWAUpsell',
  PunctuationAtMentions = 'PunctuationAtMentions',
  ReplyFlexRefactor = 'ReplyFlexRefactor',
  ReplyLinkRedesign = 'ReplyLinkRedesign',
  RestrictPostingAnyGroupRollout = 'RestrictPostingAnyGroupRollout',
  RoosterJSPublisher = 'RoosterJSPublisher',
  RoosterJSPublisherAndroid = 'RoosterJSPublisherAndroid',
  ScreenRecorderPublisher = 'ScreenRecorderPublisher',
  SearchPageAccess = 'SearchPageAccess',
  ServerSharePointWebLinks = 'ServerSharePointWebLinks',
  ShareAMAPoboToStoryline = 'ShareAMAPoboToStoryline',
  SharePointVideoLinkPreviews = 'SharePointVideoLinkPreviews',
  ShowUserCoverImage = 'ShowUserCoverImage',
  SmallFileUpload = 'SmallFileUpload',
  SplitDataAndPresentationComponents = 'SplitDataAndPresentationComponents',
  Stories = 'Stories',
  StoriesAdminSetting = 'StoriesAdminSetting',
  StoriesDescription = 'StoriesDescription',
  StoriesPostOnBehalfOfEnabled = 'StoriesPostOnBehalfOfEnabled',
  StoriesV2Cards = 'StoriesV2Cards',
  StorylineAdmin = 'StorylineAdmin',
  StorylineAdminAdvanced = 'StorylineAdminAdvanced',
  StorylineAdminGeneralAvailableEnabled = 'StorylineAdminGeneralAvailableEnabled',
  StorylineAnnouncement = 'StorylineAnnouncement',
  StorylineAnnouncementAudienceChannelsConfigEnabled = 'StorylineAnnouncementAudienceChannelsConfigEnabled',
  StorylineAnnouncementAudienceChooser = 'StorylineAnnouncementAudienceChooser',
  StorylineAnnouncementTeachingBubbleAndDisableInfobar = 'StorylineAnnouncementTeachingBubbleAndDisableInfobar',
  StorylineAnnouncementTeamsEmailChannelsEnabled = 'StorylineAnnouncementTeamsEmailChannelsEnabled',
  StorylineAsDefaultOnHomePublisher = 'StorylineAsDefaultOnHomePublisher',
  StorylineBootstrapNetworkCall = 'StorylineBootstrapNetworkCall',
  StorylineDefaultHomeFeedPublisherShort = 'StorylineDefaultHomeFeedPublisherShort',
  StorylineDefaultHomeFeedPublisherLong = 'StorylineDefaultHomeFeedPublisherLong',
  StorylineDirectAndDigestRebrand = 'StorylineDirectAndDigestRebrand',
  StorylineFeatureConversation = 'StorylineFeatureConversation',
  StorylineFollowBack = 'StorylineFollowBack',
  StorylineFREVivaEngage = 'StorylineFREVivaEngage',
  StorylinePerUserControl = 'StorylinePerUserControl',
  StorylinePostOnBehalfOfFiles = 'StorylinePostOnBehalfOfFiles',
  StorylinePremiumPreviewEnabled = 'StorylinePremiumPreviewEnabled',
  StorylinePublisherSettingsNetworkCall = 'StorylinePublisherSettingsNetworkCall',
  StorylinePublisherCoachingTips = 'StorylinePublisherCoachingTips',
  StorylineThreadCoachingTips = 'StorylineThreadCoachingTips',
  SuggestedTopicsAnswers = 'SuggestedTopicsAnswers',
  TeamsActivityNotificationStoryline = 'TeamsActivityNotificationStoryline',
  TeamsBackButton = 'TeamsBackButton',
  TeamsMeetingAccess = 'TeamsMeetingAccess',
  TeamsQnAMessageReactions = 'TeamsQnAMessageReactions',
  TeamsQnAFeedFilterOptions = 'TeamsQnAFeedFilterOptions',
  TeamsQnAFeedReset = 'TeamsQnAFeedReset',
  TeamsQnAFlatNestedReplies = 'TeamsQnAFlatNestedReplies',
  TeamsQnANotificationsDeepLinking = 'TeamsQnANotificationsDeepLinking',
  TeamsQnARemoveBestAnswer = 'TeamsQnARemoveBestAnswer',
  TeamsQnAThreadUpvote = 'TeamsQnAThreadUpvote',
  TeamsStorylineRecording = 'TeamsStorylineRecording',
  TeamsSupportFullWidthLayout = 'TeamsSupportFullWidthLayout',
  ThreadDeletion = 'ThreadDeletion',
  UserGroupsFromGrouper = 'UserGroupsFromGrouper',
  UserInsights = 'UserInsights',
  UserLeaderIdentification = 'UserLeaderIdentification',
  UserLockedAchievements = 'UserLockedAchievements',
  UserTags = 'UserTags',
  UserStoryline = 'UserStoryline',
  UserWallPostNotification = 'UserWallPostNotification',
  VivaEngageAdminWeb = 'VivaEngageAdminWeb',
  VivaEngageAma = 'VivaEngageAma',
  VivaEngageAmaDelegate = 'VivaEngageAmaDelegate',
  VivaEngageAmaCalendarInvite = 'VivaEngageAmaCalendarInvite',
  VivaEngageAmaCreation = 'VivaEngageAmaCreation',
  VivaEngageAmaCreationV2 = 'VivaEngageAmaCreationV2',
  VivaEngageAmaFeaturedEvents = 'VivaEngageAmaFeaturedEvents',
  VivaEngageAmaCoorganizers = 'VivaEngageAmaCoorganizers',
  VivaEngageAppInMetaOs = 'VivaEngageAppInMetaOs',
  VivaEngageAppUXMC = 'VivaEngageAppUXMC',
  VivaEngageBackButton = 'VivaEngageBackButton',
  VivaEngageCoverImage = 'VivaEngageCoverImage',
  VivaEngageRightUXChange = 'VivaEngageRightUXChange',
  VivaEngageSuiteNav = 'VivaEngageSuiteNav',
  VivaEngageFRE = 'VivaEngageFRE',
  VivaEngagePremium = 'VivaEngagePremium',
  VivaEngageQnA = 'VivaEngageQnA',
  VivaEngageQnAFastFollow = 'VivaEngageQnAFastFollow',
  VivaEngageCollapsiblePanelRecommendations = 'VivaEngageCollapsiblePanelRecommendations',
  VivaEngageLC = 'VivaEngageLC',
  VivaEngageStorylineAnnouncement = 'VivaEngageStorylineAnnouncement',
  VivaEngageTopicPickerTrendingTopics = 'VivaEngageTopicPickerTrendingTopics',
  VivaInsightsCampaign = 'VivaInsightsCampaign',
  VivaInsightsCampaignTopContentCreator = 'VivaInsightsCampaignTopContentCreator',
  VivaInsightsLeaders = 'VivaInsightsLeaders',
  VivaInsightsLeadersDelegationPicker = 'VivaInsightsLeadersDelegationPicker',
  VivaInsightsLeadersMyAnalytics = 'VivaInsightsLeadersMyAnalytics',
  VivaInsightsLeadersThemeSentiment = 'VivaInsightsLeadersThemeSentiment',
  VivaInsightsQnA = 'VivaInsightsQnA',
  VivaEngageRebrandingBanner = 'VivaEngageRebrandingBanner',
  VivaTopicMultiLineContentExpandControl = 'VivaTopicMultiLineContentExpandControl',
  VivaLeadershipChronoFeed = 'VivaLeadershipChronoFeed',
  VivaTopicsFRE = 'VivaTopicsFRE',
  WebRecorderV2 = 'WebRecorderV2',
  WebVitals = 'WebVitals',
  YammerFeedbackSystem = 'YammerFeedbackSystem',
  NoWFMessageBodyInGroupMessageCreationResponse = 'NoWFMessageBodyInGroupMessageCreationResponse',
  MinimalWFPayloadOnReplyPosting = 'MinimalWFPayloadOnReplyPosting',
  HydrantThreadCaching = 'HydrantThreadCaching',

  // Existing experiments that incorrectly have 'Enabled' as part of their name.
  // Do not do this - 'enabled' should be the state of an experiment, not part of the name.
  // The name should instead focus on describing the feature/functionality affected.
  // Since these are already running and in use, we can't rename them, so just have
  // to let them run their course.
  BackendRankieFeatureEnabled = 'BackendRankieFeatureEnabled',
  BackendSPNewsEnabled = 'BackendSPNewsEnabled',
  BackendSPNewsGlammer = 'BackendSPNewsGlammer',
  CortexTopicCardsEnabled = 'CortexTopicCardsEnabled',
  LiveEventSortingChangeEnabled = 'LiveEventSortingChangeEnabled',
  ModulatorGroupSuggestionsEnabled = 'ModulatorGroupSuggestionsEnabled',
  NestedRepliesEnabled = 'NestedRepliesEnabled',

  // Experiments used for testing the experiment infrastructure - grouping
  // these separately from the regular feature experiments above. Regular
  // experiments should not have the name 'experiment' in them.
  ClientForwardExperimentForTesting1 = 'ClientForwardExperimentForTesting1',
  ClientForwardExperimentForTesting2 = 'ClientForwardExperimentForTesting2',
  CrossPlatformExperimentForTesting1 = 'CrossPlatformExperimentForTesting1',
  CrossPlatformExperimentForTesting2 = 'CrossPlatformExperimentForTesting2',
  ExperimentForTesting1 = 'ExperimentForTesting1',
  ExperimentForTesting2 = 'ExperimentForTesting2',
}

export type ExperimentTreatmentValue = string | boolean | number;

export interface ExperimentConfig {
  readonly id: string | undefined;
  readonly projectTeam: EcsProjectTeamName;
  readonly treatments: ExperimentTreatmentValue[];
  readonly defaultTreatment: ExperimentTreatmentValue;
}

export const experimentConfigs: ExperimentConfigs = {
  QuickNavManageMyThings: {
    id: '6a005258-30ee-443e-9b6e-ff1024e2b8c0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MyGroupsAdminOfFilter: {
    id: 'b1be92fd-10e9-404b-9ea0-9c987e54a8eb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnalyticsEventsStrictSchema: {
    id: '522ba782-172c-4a40-b569-6048a16bd73b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnalyticsAdminSetting: {
    id: '872099b2-7bc9-459c-a380-934612e7213b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersInVivaGA: {
    id: '380a21a6-bc1e-4619-aa37-f11e947f9844',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersOnlyMode: {
    id: 'adfa8eca-2626-43df-9693-da8f9ba34bd7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersPostGAExperience: {
    id: 'b2b9090e-7752-4050-bf20-831f2c940ea9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswerUpvoteRedesign: {
    id: '4f9555aa-a589-487f-8b8b-a8a43fa3b9ab',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AtMentionCustomName: {
    id: '0f7581eb-ad8e-4acc-80fa-75214dd00bed',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoSuggestionCampaignHashtag: {
    id: 'acc4854f-ed9d-4082-8f56-5f2bba1d2bed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphqlApiVnextEndpoint: {
    id: 'fd389c01-9fdd-440d-af71-41aab31f2a57',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [0, 1, 2, 3],
    defaultTreatment: 0,
  },
  BackendLiveEventFeedCaching: {
    id: '298a9ad9-4a09-4bc9-b03c-57409c423b7e',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCachingByTenant: {
    id: 'cf0d025e-c359-4988-8ab4-abed3a5f7e77',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendOcularCosmos: {
    id: '6efb151f-2e3b-466f-9fac-d14928e0d815',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BackendRankieFeatureEnabled: {
    id: '27ed230b-3dd8-436e-b577-131fb9b58500',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendRankieForwardTreatments: {
    id: 'e1632dd4-4cb4-41b0-b882-188ba647a795',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BackendSPNewsEnabled: {
    id: '517c7ed4-9165-413e-b6d1-a824f483bb6c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendSPNewsGlammer: {
    id: '93683b8e-a698-42ec-9327-07fc88fc803e',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BellPageSize: {
    id: '5d034307-8927-41cc-bdc1-2b9b000bc466',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BookmarkThread: {
    id: '73b842f4-791f-4157-a5b2-76917957057f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Campaigns: {
    id: '64ddebd5-e905-48bc-bd39-38f059e55dfc',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorship: {
    id: '671d7ef6-08c8-4643-84c6-be6fe85d3df3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSash: {
    id: '8beebaa4-70c8-44aa-be6a-ce95ef183c43',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsKillSwitchUI: {
    id: '05dd7188-d9ef-4191-8f31-961e23a3cf8c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClearPublisher: {
    id: '07f24914-f032-4e84-bed0-69e292e0e81d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityBadgeAdmin: {
    id: 'ace0c8c8-713f-433d-9807-2617506e7cbb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLiveEventsBanner: {
    id: 'e6c21c31-b85a-4710-9452-88be53ab9ca3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityManagerSubscriptionTip: {
    id: '44568163-115a-4170-b9c8-0314dab7745d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySetupTeachingBubbles: {
    id: '9665f8af-afb7-4f17-83d6-dcaa4e7ea275',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySubscriptionBubbleOnly: {
    id: '62b198ee-a1ea-4235-af37-36e43c16942c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompanyLogoInLCHeader: {
    id: 'ca32a32d-1b98-44ab-87fc-de35ef47838e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CortexTopicCardsEnabled: {
    id: 'ae26490b-84e4-4c54-b485-97dafc981ec2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ContextualAtMentioning: {
    id: '22890268-9ab0-46d5-8b6d-5cccf1891f3a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CondensedCardHomeFeed: {
    id: 'ae3bdd49-bf98-4787-89f0-ed46515f343d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CSVUploadGroupMembers: {
    id: 'c435b040-40d3-4e6d-98ec-321f6229e34d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CSVUploadGroupMembersV2: {
    id: '330bfa3a-3aa0-484a-a350-143b63be161c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClientForwardExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  ClientForwardExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CrossPlatformExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  CrossPlatformExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverCommunitiesV2: {
    id: '39b449a2-1fd5-4599-89d0-e2a86a1a16a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['disabled', 'enabled'],
    defaultTreatment: 'disabled',
  },
  DiscoverOfficialCommunities: {
    id: 'b1de80d6-8d37-4ac3-980e-22264edb9654',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPostCommunity: {
    id: 'ac5794d4-f2a5-4b78-89e7-9c3be86554c1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPostStoryline: {
    id: '5b7fdb04-9145-4a3f-adff-1a83940e6be9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DwellTimeReporting: {
    id: '6598b5fb-5c58-4dac-b3ef-f5935c74298c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  EmbedMsal: {
    id: '012d222c-422f-446b-8477-c5dcad4cc15a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedSupportForNetworkContext: {
    id: '2cf796ba-c50e-4098-b278-e200b4bece9d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedUseAttachableLinkQuery: {
    id: '5b2c38aa-dba0-4cb0-93f6-8d1a42545b27',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnhancedDigestDiscoveryDesign: {
    id: '281e84a8-537f-4440-93e2-9b7c91289a99',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'all_surfaces', 'list_view', 'reading_pane'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting1: {
    id: 'fake-guid-for-testing',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 't1'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExternalNetworksInGlammer: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  FavoritesDragDropReorder: {
    id: '83593909-57d5-49e8-b3f4-eca2e2c142d2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  FollowButtonHomeFeedThreadWithGreyColor: {
    id: '440bb634-1b43-44c8-9251-e9d02a469570',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupsFromGrouper: {
    id: '49b25bb2-375e-46ce-8624-6224d5254df0',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFollowingFeed: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  InFeedUserSuggestions: {
    id: 'edc8645c-a10d-4ab1-aab3-34842a682c5d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'rankie', 'enabled'],
    defaultTreatment: 'control',
  },
  GlammerMomentsNotifications: {
    id: 'c435a12a-3ee3-43e9-82fd-fe9ba3046a55',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupHoverCardV2: {
    id: 'e22b6ca1-ad23-4176-afbf-ab7b9365648e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupRecommendedFeed: {
    id: '8fb58315-f5c5-4fad-8c7b-623faf57ff6e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderAudienceFeed: {
    id: '45242ffb-565d-45c3-9aec-cead8078233c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeadershipManagement: {
    id: '0c10cfbf-0a5c-44b9-afcb-40ff9c94669f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersAudienceMS365Groups: {
    id: 'fc767b4c-89f0-46f4-8ff8-daacee9e02c3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadershipLiveEventsBanner: {
    id: '6e64a6f2-ea2e-46ac-b15e-ceb156efe4e8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderGroupsAddAsync: {
    id: 'c67be930-601d-40f2-a300-b3027ea21b10',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LightboxFollowUsers: {
    id: 'd34c34e0-815c-4133-a17d-fe181895cf4d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LiveEventSortingChangeEnabled: {
    id: '33d94caa-e259-4c4f-be93-656012fe9b84',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LongFormContentArticlePublisher: {
    id: '202f8671-9322-4bef-9922-b1ab63deca87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LongFormContentFormattingOptions: {
    id: '202f8671-9322-4bef-9922-b1ab63deca87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  RestrictPostingAnyGroupRollout: {
    id: 'de3b6c60-f521-4e7d-b89a-2c8d19d81785',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModulatorGroupSuggestionsEnabled: {
    id: 'bfd3fd32-6e3c-41c0-a792-8962dab5d283',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MomentsCreation: {
    id: '893ecc3b-4d89-49e2-b85d-2094e69ff6f8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiTenantOrganization: {
    id: 'faa2b44b-bbdb-489b-84d3-ea8c6881d9f1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NotificationsUpsell: {
    id: '78d39926-96c0-4865-8840-f21536dc7df8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  NotificationsUpsellLongTerm: {
    id: '3a2edb9c-745f-4d4e-b1b9-6beefc8abecb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  OneCameraV3: {
    id: 'b4c0de9d-144f-4dd5-9357-f6453c73d48b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerNative: {
    id: 'c014fb1e-2d91-47e7-9d63-005fa8fd0490',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinePostFeedback: {
    id: 'dbb000fa-5cad-439b-8acf-0c71e6b3917f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinesDigestFollowSenderButton: {
    id: '9729aeb6-144b-413a-a06b-9fe4024fcb34',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinesDigestStoriesCarousel: {
    id: 'a54981ee-a553-4b39-a1fb-92dd6bdca250',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinesDigestSuggestedUsers: {
    id: '87922e3c-fca4-40d8-849f-b5c34298ee2b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAStorylinesDigestTeachingBubble: {
    id: '57f386b4-13e0-4016-8df5-f48f38c014ad',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OdspFilePickerType: {
    id: 'a316df71-760f-47ec-97fd-84e11f14017c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'group', 'onedrive'],
    defaultTreatment: 'control',
  },
  OfficeTopics: {
    id: 'fbd301cf-0130-4803-a7ed-f083f9a9b91f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OfficeTopicsWithNetCore: {
    id: '0b624950-f776-4f71-9e00-7e74ec3d1043',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OfficialCommunityBadge: {
    id: '9f626a2e-53e8-4561-b42b-1c9e69bc0f65',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OutlookAnswersDigestTopics: {
    id: '5d05b525-0bf2-44ec-9be9-36c2b40be53e',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OutlookPublisherGuide: {
    id: 'faa2f6ee-9479-4a9f-9bb8-b04fe7184c6b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OverrideAndDisableStorylineAnnouncements: {
    id: 'eadeebf7-56b1-4d01-9b95-556c3f1b4f26',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PageLayoutVNextVivaEngage: {
    id: '97bb30f4-acf1-4866-bcc0-c801c20679e5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PageLayoutVNextWebApp: {
    id: 'ffa2319c-306e-492f-96dd-2b8c7a8733ce',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PageThreadHomeFeed: {
    id: '297975e3-1a9f-4f4b-9248-019eaf25fac1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PeopleSuggestion3SV3: {
    id: '5d873e2e-b60c-43d5-801a-716cce0894bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  PinnedFiles: {
    id: 'b2b7ae31-803f-42f8-833b-5d99489cc3a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PWAUpsell: {
    id: 'd8ec02af-aae1-405b-8701-adc4e7d774bf',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PublisherSuggestedTopics: {
    id: 'df2bddf4-61dd-4bc5-a1c7-778939fe36ae',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PunctuationAtMentions: {
    id: '7f24c984-af28-49e9-b011-7467c944f9ec',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReplyFlexRefactor: {
    id: 'a4f460c9-cb68-41c7-b043-f1f745c3816e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReplyLinkRedesign: {
    id: 'a2a61e9d-e6fd-4a2c-baff-a12657915a69',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RoosterJSPublisher: {
    id: 'c0ae296c-cfbb-4f2b-8529-94b724e0c55e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RoosterJSPublisherAndroid: {
    id: '55145bb0-0f77-42eb-90d9-73d32691eba8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchPageAccess: {
    id: 'fa5310b5-3f7c-42e9-8e65-be17f1b163b6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ShowUserCoverImage: {
    id: '1b55e8eb-36f3-4022-ac2c-2588d3869931',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SmallFileUpload: {
    id: '8c7e99ba-f485-46ea-9c15-963168beaf73',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SplitDataAndPresentationComponents: {
    id: '7bab3ae5-1adc-46f4-ba94-d301aa631953',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  Stories: {
    id: '06ca9171-c49a-4437-87ff-db71db80eca0',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesAdminSetting: {
    id: '77845d48-b176-4f58-8fc6-6e251ec79dba',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesDescription: {
    id: 'ce921fc2-c2c1-476e-a605-4dc4e43dcf11',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesPostOnBehalfOfEnabled: {
    id: '466fb696-01ba-46f9-b815-5841afd683d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesV2Cards: {
    id: '8ce624f9-6d36-46be-a1b8-66a4e9200e0c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAdmin: {
    id: '2cf7f27f-36b0-404e-9e9f-f756a2610bd4',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAdminAdvanced: {
    id: 'dbdea94d-0c86-439a-a221-119b7ec329d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAdminGeneralAvailableEnabled: {
    id: '7a2df625-43b9-4acd-a37b-264eb742a9a1',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncement: {
    id: '63dcaeb4-9f44-4b60-862c-d66b6b91138f',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementAudienceChannelsConfigEnabled: {
    id: '815edf06-def6-4e9e-93f5-dee926e9c4ad',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementAudienceChooser: {
    id: '8f89b5ff-6de1-42c2-a54c-b7d72c6e1254',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementTeachingBubbleAndDisableInfobar: {
    id: '8714e391-0b32-4202-9c11-5da24443b1c5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementTeamsEmailChannelsEnabled: {
    id: 'bda9c5a1-3e58-40ce-8525-04605ef7fb28',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAsDefaultOnHomePublisher: {
    id: '607d8f62-67cc-46dd-8ab9-05dfe7093edf',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineBootstrapNetworkCall: {
    id: '6e42a50a-6e69-4530-95db-d031602db681',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherShort: {
    id: 'd1f8e500-de05-4d9b-89f7-547163defb89',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherLong: {
    id: 'a89e5dbd-0367-48fe-893f-7599553340f5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDirectAndDigestRebrand: {
    id: 'a9c87cbf-fbab-45b9-b081-0d60f239ce37',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeatureConversation: {
    id: 'd7bd2914-15a3-4557-a105-46f340f6ee97',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFollowBack: {
    id: 'e134b15f-4875-4f81-b180-a2777912074d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFREVivaEngage: {
    id: 'af384543-6d30-4364-86ed-a119538de985',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePerUserControl: {
    id: '974480fc-4e4d-472a-8785-aead29cab958',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePostOnBehalfOfFiles: {
    id: '59406740-42da-404e-a41d-23324e366f0d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePremiumPreviewEnabled: {
    id: 'f1d5bdbe-186d-440e-b4b6-0ce444d1799a',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherSettingsNetworkCall: {
    id: '968afe62-d291-42c8-8816-9b5d99d86cfa',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherCoachingTips: {
    id: '31c06d83-f8eb-4423-a704-9294705c5ab5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineThreadCoachingTips: {
    id: 'd02b84c7-32c3-42f4-8edc-a9116e7054cc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SuggestedTopicsAnswers: {
    id: '0695670d-e191-4bdc-9e21-b6869f82cc4e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TeamsActivityNotificationStoryline: {
    id: '18fc375c-e7d8-43fd-919a-72d91d9a8d95',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBackButton: {
    id: 'db934c10-1fe1-4027-8489-eb325e129cdc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingAccess: {
    id: 'a1e4ad9b-3252-476f-8d36-d1ab593eea1e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAMessageReactions: {
    id: '5c5e3512-c64c-49c7-9e4c-80196146e719',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedFilterOptions: {
    id: '864ed27f-9073-4122-aadd-96b4eb9ffe32',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedReset: {
    id: '843e64a0-d562-462b-bc22-14404b918cad',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFlatNestedReplies: {
    id: 'c608a65c-ec10-44e3-82f1-acbb4169827e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANotificationsDeepLinking: {
    id: 'f051bee8-8271-4a36-9d5c-cfba7c37ff9f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TeamsQnARemoveBestAnswer: {
    id: '79b20ced-9a70-4b86-bea5-3ad9b5828b0a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAThreadUpvote: {
    id: '579fb564-0151-42d3-9416-4f9e351770a1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsStorylineRecording: {
    id: 'b2f2a552-4728-49b3-89ee-07bb0bc61833',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsSupportFullWidthLayout: {
    id: 'd3654b05-e089-49a4-a25d-a9c0a5feb2e1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ThreadDeletion: {
    id: 'ef1d8f23-86a0-4d00-8fd0-a21339c23355',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserGroupsFromGrouper: {
    id: 'e745b9c1-095b-45f6-a2aa-a4989bb2c0d8',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaTopicMultiLineContentExpandControl: {
    id: '7ca90aaa-5738-4ffa-8b22-a7ab59637d2c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserTags: {
    id: 'cc278c50-d599-4b2f-9a7d-33548c2cfd79',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserWallPostNotification: {
    id: '22e73b8f-6684-416b-b4fd-39d87505e01d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserInsights: {
    id: '7d5f49c9-25c0-46fd-8679-83880a68708a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserLeaderIdentification: {
    id: '896a02e9-e6ff-47c6-8309-78c2610acacf',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserLockedAchievements: {
    id: 'c8123b8d-7662-4fb1-b4b0-5024e30c7530',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserStoryline: {
    id: 'ae197ce2-a0af-41e8-bd77-5d0ffca83ce1',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ServerSharePointWebLinks: {
    id: 'cb6da583-69f6-422d-ba1c-0d1bf9af85e8',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ShareAMAPoboToStoryline: {
    id: '6649bf4b-142b-4061-a46c-a1b2103d6551',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointVideoLinkPreviews: {
    id: '28323fd7-5caa-420d-998d-88f9224d9698',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NestedRepliesEnabled: {
    id: 'c00dd4e9-6573-400d-9c46-c3cb2d115f3e',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherAbandonmentOCVSurvey: {
    id: '96eea534-dc14-4e29-a10b-cd4c3ace6545',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ScreenRecorderPublisher: {
    id: '316bf8ff-94c0-47f6-ab15-a5519cd7f7b8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'promoted', 'subitem'],
    defaultTreatment: 'control',
  },
  VivaEngageAdminWeb: {
    id: 'acaac5a2-737f-4542-95a6-e536b7039b47',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAma: {
    id: '2517789b-51c8-441e-aaab-b0251e2ea6f3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaDelegate: {
    id: '1d0eb473-6812-482d-9ce4-bf514a9bccc1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCalendarInvite: {
    id: 'eea95241-fcdc-4158-b266-55429904071b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCreation: {
    id: 'ebe531d4-b727-478b-9a60-e70c6517af77',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCreationV2: {
    id: '0fe5340a-6d16-4697-a22f-bc6848d1b4dc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaFeaturedEvents: {
    id: '0e20041a-02d2-42c9-994d-7e91b531ce6a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCoorganizers: {
    id: '23c1381a-ec60-43d5-a84a-c2985936a829',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAppInMetaOs: {
    id: '87138c5a-531c-4beb-9213-542ab5bdc4d6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAppUXMC: {
    id: 'e732f6c2-0d9f-4a87-9654-2069399dbdd6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'treatment', 'oldux'],
    defaultTreatment: 'control',
  },
  VivaEngageBackButton: {
    id: 'c5ecc24e-af94-484f-827b-999da6165586',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCoverImage: {
    id: '52589660-bd2e-495b-8264-3729d18bbbb5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageRightUXChange: {
    id: 'fc98c1d3-cc91-4e15-9588-56b6c3810239',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'treatmenta', 'treatmentb', 'treatmentc', 'treatmentd'],
    defaultTreatment: 'control',
  },
  VivaEngageSuiteNav: {
    id: 'a2f6aca9-579c-4195-af8b-19a09ee2291d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageFRE: {
    id: '17302ce9-8e78-48d2-a754-0ad3a3f75f2e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngagePremium: {
    id: '7967125b-c339-443b-927f-c7f0a908ae30',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageQnA: {
    id: '018fb6ce-0f78-48c8-b263-277bd487893c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageQnAFastFollow: {
    id: '9aff7a51-f6b5-4f4b-83d8-9bbf00d93b74',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCollapsiblePanelRecommendations: {
    id: '2cc0b58b-35a0-47d8-aee4-51c37f7aef0b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageLC: {
    id: 'f01b8142-2f47-492c-a640-b3836b8b7afc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageStorylineAnnouncement: {
    id: '57077c48-b131-4ca2-8775-70b17ac94ff7',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageTopicPickerTrendingTopics: {
    id: '333ea886-87a1-4436-bc0a-933ed394bbdc',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: 'control',
  },
  VivaInsightsCampaign: {
    id: '787fefa8-90aa-4ce7-806d-4b0865bc045e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsCampaignTopContentCreator: {
    id: '1a6556da-3664-4703-b682-00f082a6016b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsLeaders: {
    id: '0911e383-c639-4c30-9fbb-3772130e674c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsLeadersDelegationPicker: {
    id: 'b571444e-68a7-47a8-b9ab-f9251fc816a2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsLeadersMyAnalytics: {
    id: '1a6556da-3664-4703-b682-00f082a6016b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsLeadersThemeSentiment: {
    id: 'ee72ba49-df9b-488e-be9a-be0bff9f4870',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsQnA: {
    id: '64e6ea03-43c9-44a7-bc7e-807b6a9e451f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipChronoFeed: {
    id: '0bc20bf9-4197-40fe-b262-912c9bebf58b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRebrandingBanner: {
    id: '9cee3a74-b547-43a7-939d-a0aa9b5a9de7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaTopicsFRE: {
    id: '8248931d-3124-4aa8-863c-46b8a44fa60a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  WebRecorderV2: {
    id: 'a284e218-ec93-40bb-92d2-81bcd51b9b5f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  WebVitals: {
    id: '2fc9f483-1112-47e3-8063-0ae5d73cc634',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  YammerFeedbackSystem: {
    id: 'f70e29db-cc6e-4622-984f-004442019b12',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NoWFMessageBodyInGroupMessageCreationResponse: {
    id: '9c4d957c-94b1-43d8-bcc6-84a14db0cde2',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MinimalWFPayloadOnReplyPosting: {
    id: '4def6d5d-ad49-4be4-8d63-dede011d672f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  HydrantThreadCaching: {
    id: '1e3fe465-fd1b-4e82-a5d6-91da4e59361b',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
};

export type ExperimentConfigs = Record<Experiment, ExperimentConfig>;

export type ExperimentTreatments = Record<Experiment, ExperimentTreatmentValue>;

export const defaultExperimentTreatments = (Object.keys(experimentConfigs) as Experiment[]).reduce(
  (acc: Record<Experiment, ExperimentTreatmentValue>, key: Experiment) => ({
    ...acc,
    [key]: experimentConfigs[key].defaultTreatment,
  }),
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  {} as Record<Experiment, ExperimentTreatmentValue>
);

export interface EcsExperiments {
  readonly treatments: ExperimentTreatments;
  readonly treatmentsFromService: Partial<ExperimentTreatments>;
  readonly treatmentOverrides: Partial<ExperimentTreatments>;
}
